/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchChangeRequestReviewsJobRunsAggregateBoolExp = {
  count?: BatchChangeRequestReviewsJobRunsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_request_reviews_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobRunsBoolExp = {
  _and?: Array<BatchChangeRequestReviewsJobRunsBoolExp> | null | undefined;
  _not?: BatchChangeRequestReviewsJobRunsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestReviewsJobRunsBoolExp> | null | undefined;
  batchChangeRequestReviewsJob?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  batchChangeRequestReviewsJobId?: UuidComparisonExp | null | undefined;
  comment?: StringComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsSelectColumn =
  /** column name */
  | 'batchChangeRequestReviewsJobId'
  /** column name */
  | 'comment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 's3LogPath'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

export type BatchChangeRequestReviewsJobsAggregateBoolExp = {
  count?: BatchChangeRequestReviewsJobsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_request_reviews_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobsBoolExp = {
  _and?: Array<BatchChangeRequestReviewsJobsBoolExp> | null | undefined;
  _not?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestReviewsJobsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobRuns?: BatchChangeRequestReviewsJobRunsBoolExp | null | undefined;
  batchChangeRequestReviewsJobRunsAggregate?: BatchChangeRequestReviewsJobRunsAggregateBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  reviewTypeId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'reviewTypeId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp = {
  count?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_requests_job_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRecordComposerDefinitionsBoolExp = {
  _and?: Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type BatchChangeRequestsJobRunsAggregateBoolExp = {
  count?: BatchChangeRequestsJobRunsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_requests_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRunsBoolExp = {
  _and?: Array<BatchChangeRequestsJobRunsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobRunsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  changeRequests?: ChangeRequestsBoolExp | null | undefined;
  changeRequestsAggregate?: ChangeRequestsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  mappingLog?: JsonbComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'mappingLog'
  /** column name */
  | 's3LogPath'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

export type BatchChangeRequestsJobsAggregateBoolExp = {
  count?: BatchChangeRequestsJobsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_requests_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobsBoolExp = {
  _and?: Array<BatchChangeRequestsJobsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobs?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  batchChangeRequestReviewsJobsAggregate?: BatchChangeRequestReviewsJobsAggregateBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitions?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  batchChangeRequestsJobRuns?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  batchChangeRequestsJobRunsAggregate?: BatchChangeRequestsJobRunsAggregateBoolExp | null | undefined;
  changeRequests?: ChangeRequestsBoolExp | null | undefined;
  changeRequestsAggregate?: ChangeRequestsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobTypeId?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'id'
  /** column name */
  | 'jobTypeId'
  /** column name */
  | 'name'
  /** column name */
  | 's3Path'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type BatchEvidencesJobRunsAggregateBoolExp = {
  count?: BatchEvidencesJobRunsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_evidences_job_runs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobRunsBoolExp = {
  _and?: Array<BatchEvidencesJobRunsBoolExp> | null | undefined;
  _not?: BatchEvidencesJobRunsBoolExp | null | undefined;
  _or?: Array<BatchEvidencesJobRunsBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobResult?: JsonbComparisonExp | null | undefined;
  mappingLog?: JsonbComparisonExp | null | undefined;
  outputMode?: StringComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'jobResult'
  /** column name */
  | 'mappingLog'
  /** column name */
  | 'outputMode'
  /** column name */
  | 's3LogPath'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

export type BatchEvidencesJobsAggregateBoolExp = {
  count?: BatchEvidencesJobsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_evidences_jobs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobsBoolExp = {
  _and?: Array<BatchEvidencesJobsBoolExp> | null | undefined;
  _not?: BatchEvidencesJobsBoolExp | null | undefined;
  _or?: Array<BatchEvidencesJobsBoolExp> | null | undefined;
  batchEvidencesJobRuns?: BatchEvidencesJobRunsBoolExp | null | undefined;
  batchEvidencesJobRunsAggregate?: BatchEvidencesJobRunsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceImporter?: EvidenceImportersBoolExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobTypeId?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  unifiedEvidenceDrafts?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  unifiedEvidenceDraftsAggregate?: UnifiedEvidenceDraftsAggregateBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'id'
  /** column name */
  | 'jobTypeId'
  /** column name */
  | 'name'
  /** column name */
  | 's3Path'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

export type CategoriesAggregateBoolExp = {
  count?: CategoriesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type CategoriesBoolExp = {
  _and?: Array<CategoriesBoolExp> | null | undefined;
  _not?: CategoriesBoolExp | null | undefined;
  _or?: Array<CategoriesBoolExp> | null | undefined;
  categoryPath?: CategoryPathsBoolExp | null | undefined;
  categoryPropertySchemaSet?: CategoryPropertySchemaSetsBoolExp | null | undefined;
  categoryPropertySchemaSetAggregate?: CategoryPropertySchemaSetsAggregateBoolExp | null | undefined;
  categoryType?: CategoryTypesBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordMetadataCategories?: RecordMetadataCategoriesBoolExp | null | undefined;
  recordMetadataCategoriesAggregate?: RecordMetadataCategoriesAggregateBoolExp | null | undefined;
  relationType?: RelationTypesBoolExp | null | undefined;
  relationTypeId?: UuidComparisonExp | null | undefined;
  sourceRelationTypes?: RelationTypesBoolExp | null | undefined;
  sourceRelationTypesAggregate?: RelationTypesAggregateBoolExp | null | undefined;
  targetRelationTypes?: RelationTypesBoolExp | null | undefined;
  targetRelationTypesAggregate?: RelationTypesAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  typeId?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "categories" */
export type CategoriesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'description'
  /** column name */
  | 'documentUrl'
  /** column name */
  | 'i18nLabel'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'relationTypeId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'typeId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "category_paths". All fields are combined with a logical 'AND'. */
export type CategoryPathsBoolExp = {
  _and?: Array<CategoryPathsBoolExp> | null | undefined;
  _not?: CategoryPathsBoolExp | null | undefined;
  _or?: Array<CategoryPathsBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  path?: LtreeComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type CategoryPropertySchemaSetsAggregateBoolExp = {
  count?: CategoryPropertySchemaSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "category_property_schema_sets". All fields are combined with a logical 'AND'. */
export type CategoryPropertySchemaSetsBoolExp = {
  _and?: Array<CategoryPropertySchemaSetsBoolExp> | null | undefined;
  _not?: CategoryPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<CategoryPropertySchemaSetsBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsSelectColumn =
  /** column name */
  | 'categoryId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "category_types". All fields are combined with a logical 'AND'. */
export type CategoryTypesBoolExp = {
  _and?: Array<CategoryTypesBoolExp> | null | undefined;
  _not?: CategoryTypesBoolExp | null | undefined;
  _or?: Array<CategoryTypesBoolExp> | null | undefined;
  categories?: CategoriesBoolExp | null | undefined;
  categoriesAggregate?: CategoriesAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestCommitsBoolExp = {
  _and?: Array<ChangeRequestCommitsBoolExp> | null | undefined;
  _not?: ChangeRequestCommitsBoolExp | null | undefined;
  _or?: Array<ChangeRequestCommitsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  items?: ChangeRequestItemCommitsBoolExp | null | undefined;
  itemsAggregate?: ChangeRequestItemCommitsAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type ChangeRequestItemCommitsAggregateBoolExp = {
  count?: ChangeRequestItemCommitsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemCommitsBoolExp = {
  _and?: Array<ChangeRequestItemCommitsBoolExp> | null | undefined;
  _not?: ChangeRequestItemCommitsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemCommitsBoolExp> | null | undefined;
  changeRequestCommit?: ChangeRequestCommitsBoolExp | null | undefined;
  changeRequestCommitId?: UuidComparisonExp | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_request_item_commits" */
export type ChangeRequestItemCommitsSelectColumn =
  /** column name */
  | 'changeRequestCommitId'
  /** column name */
  | 'changeRequestItemId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'properties'
  /** column name */
  | 'tenantId';

export type ChangeRequestItemRecordMetadataAggregateBoolExp = {
  count?: ChangeRequestItemRecordMetadataAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_record_metadata". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordMetadataBoolExp = {
  _and?: Array<ChangeRequestItemRecordMetadataBoolExp> | null | undefined;
  _not?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemRecordMetadataBoolExp> | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataSelectColumn =
  /** column name */
  | 'changeRequestItemId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'recordMetadataId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type ChangeRequestItemRecordsAggregateBoolExp = {
  count?: ChangeRequestItemRecordsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_records". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordsBoolExp = {
  _and?: Array<ChangeRequestItemRecordsBoolExp> | null | undefined;
  _not?: ChangeRequestItemRecordsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemRecordsBoolExp> | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "change_request_item_records" */
export type ChangeRequestItemRecordsSelectColumn =
  /** column name */
  | 'changeRequestItemId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'recordId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type ChangeRequestItemsAggregateBoolExp = {
  count?: ChangeRequestItemsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_items". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemsBoolExp = {
  _and?: Array<ChangeRequestItemsBoolExp> | null | undefined;
  _not?: ChangeRequestItemsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  changeRequestItemRecord?: ChangeRequestItemRecordsBoolExp | null | undefined;
  changeRequestItemRecordMetadata?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  commit?: ChangeRequestItemCommitsBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  modelType?: StringComparisonExp | null | undefined;
  operationType?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "change_request_items" */
export type ChangeRequestItemsSelectColumn =
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'modelType'
  /** column name */
  | 'operationType'
  /** column name */
  | 'properties'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExp = {
  count?: ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type ChangeRequestRecordComposerDefinitionsBoolExp = {
  _and?: Array<ChangeRequestRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<ChangeRequestRecordComposerDefinitionsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsSelectColumn =
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId';

/** Boolean expression to filter rows from the table "change_request_review_types". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewTypesBoolExp = {
  _and?: Array<ChangeRequestReviewTypesBoolExp> | null | undefined;
  _not?: ChangeRequestReviewTypesBoolExp | null | undefined;
  _or?: Array<ChangeRequestReviewTypesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ChangeRequestReviewsAggregateBoolExp = {
  count?: ChangeRequestReviewsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_reviews". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewsBoolExp = {
  _and?: Array<ChangeRequestReviewsBoolExp> | null | undefined;
  _not?: ChangeRequestReviewsBoolExp | null | undefined;
  _or?: Array<ChangeRequestReviewsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobRunId?: UuidComparisonExp | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  comment?: StringComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  type?: ChangeRequestReviewTypesBoolExp | null | undefined;
  typeId?: StringComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_request_reviews" */
export type ChangeRequestReviewsSelectColumn =
  /** column name */
  | 'batchChangeRequestReviewsJobRunId'
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'comment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'typeId'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "change_request_statuses". All fields are combined with a logical 'AND'. */
export type ChangeRequestStatusesBoolExp = {
  _and?: Array<ChangeRequestStatusesBoolExp> | null | undefined;
  _not?: ChangeRequestStatusesBoolExp | null | undefined;
  _or?: Array<ChangeRequestStatusesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ChangeRequestsAggregateBoolExp = {
  count?: ChangeRequestsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_requests". All fields are combined with a logical 'AND'. */
export type ChangeRequestsBoolExp = {
  _and?: Array<ChangeRequestsBoolExp> | null | undefined;
  _not?: ChangeRequestsBoolExp | null | undefined;
  _or?: Array<ChangeRequestsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  batchChangeRequestsJobRun?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  batchChangeRequestsJobRunId?: UuidComparisonExp | null | undefined;
  changeRequestRecordComposerDefinition?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  commit?: ChangeRequestCommitsBoolExp | null | undefined;
  composerKey?: StringComparisonExp | null | undefined;
  context?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  evidenceChangeRequestsAggregate?: EvidenceChangeRequestsAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  items?: ChangeRequestItemsBoolExp | null | undefined;
  itemsAggregate?: ChangeRequestItemsAggregateBoolExp | null | undefined;
  reviews?: ChangeRequestReviewsBoolExp | null | undefined;
  reviewsAggregate?: ChangeRequestReviewsAggregateBoolExp | null | undefined;
  status?: ChangeRequestStatusesBoolExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_requests" */
export type ChangeRequestsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'batchChangeRequestsJobRunId'
  /** column name */
  | 'composerKey'
  /** column name */
  | 'context'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "data_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: Array<DataImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: DataImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<DataImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type DataImportProjectStatusLogsAggregateBoolExp = {
  count?: DataImportProjectStatusLogsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_project_status_logs". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusLogsBoolExp = {
  _and?: Array<DataImportProjectStatusLogsBoolExp> | null | undefined;
  _not?: DataImportProjectStatusLogsBoolExp | null | undefined;
  _or?: Array<DataImportProjectStatusLogsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataImportProjectStatus?: DataImportProjectStatusesBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'id'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "data_import_project_statuses". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusesBoolExp = {
  _and?: Array<DataImportProjectStatusesBoolExp> | null | undefined;
  _not?: DataImportProjectStatusesBoolExp | null | undefined;
  _or?: Array<DataImportProjectStatusesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type DataImportProjectUsersAggregateBoolExp = {
  count?: DataImportProjectUsersAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_project_users". All fields are combined with a logical 'AND'. */
export type DataImportProjectUsersBoolExp = {
  _and?: Array<DataImportProjectUsersBoolExp> | null | undefined;
  _not?: DataImportProjectUsersBoolExp | null | undefined;
  _or?: Array<DataImportProjectUsersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "data_import_project_users" */
export type DataImportProjectUsersSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "data_import_projects". All fields are combined with a logical 'AND'. */
export type DataImportProjectsBoolExp = {
  _and?: Array<DataImportProjectsBoolExp> | null | undefined;
  _not?: DataImportProjectsBoolExp | null | undefined;
  _or?: Array<DataImportProjectsBoolExp> | null | undefined;
  batchChangeRequestsJobs?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobsAggregate?: BatchChangeRequestsJobsAggregateBoolExp | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectStatus?: DataImportProjectStatusesBoolExp | null | undefined;
  dataImportProjectStatusLogs?: DataImportProjectStatusLogsBoolExp | null | undefined;
  dataImportProjectStatusLogsAggregate?: DataImportProjectStatusLogsAggregateBoolExp | null | undefined;
  dataImportProjectUsers?: DataImportProjectUsersBoolExp | null | undefined;
  dataImportProjectUsersAggregate?: DataImportProjectUsersAggregateBoolExp | null | undefined;
  dataSourceImportProjects?: DataSourceImportProjectsBoolExp | null | undefined;
  dataSourceImportProjectsAggregate?: DataSourceImportProjectsAggregateBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  endDate?: TimestamptzComparisonExp | null | undefined;
  evidenceSetImportProjects?: EvidenceSetImportProjectsBoolExp | null | undefined;
  evidenceSetImportProjectsAggregate?: EvidenceSetImportProjectsAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  seq?: IntComparisonExp | null | undefined;
  startDate?: TimestamptzComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_gsheets". All fields are combined with a logical 'AND'. */
export type DataSourceGsheetsBoolExp = {
  _and?: Array<DataSourceGsheetsBoolExp> | null | undefined;
  _not?: DataSourceGsheetsBoolExp | null | undefined;
  _or?: Array<DataSourceGsheetsBoolExp> | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  googleAppsScriptId?: StringComparisonExp | null | undefined;
  googleSheetId?: IntComparisonExp | null | undefined;
  googleSpreadsheetId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: DataSourceImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  dataSourceImportProject?: DataSourceImportProjectsBoolExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type DataSourceImportProjectsAggregateBoolExp = {
  count?: DataSourceImportProjectsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_import_projects". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectsBoolExp = {
  _and?: Array<DataSourceImportProjectsBoolExp> | null | undefined;
  _not?: DataSourceImportProjectsBoolExp | null | undefined;
  _or?: Array<DataSourceImportProjectsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "data_source_import_projects" */
export type DataSourceImportProjectsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "data_source_jsons". All fields are combined with a logical 'AND'. */
export type DataSourceJsonsBoolExp = {
  _and?: Array<DataSourceJsonsBoolExp> | null | undefined;
  _not?: DataSourceJsonsBoolExp | null | undefined;
  _or?: Array<DataSourceJsonsBoolExp> | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type DataSourcePropertySchemaSetsAggregateBoolExp = {
  count?: DataSourcePropertySchemaSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourcePropertySchemaSetsBoolExp = {
  _and?: Array<DataSourcePropertySchemaSetsBoolExp> | null | undefined;
  _not?: DataSourcePropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<DataSourcePropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type DataSourceReferencesAggregateBoolExp = {
  count?: DataSourceReferencesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_references". All fields are combined with a logical 'AND'. */
export type DataSourceReferencesBoolExp = {
  _and?: Array<DataSourceReferencesBoolExp> | null | undefined;
  _not?: DataSourceReferencesBoolExp | null | undefined;
  _or?: Array<DataSourceReferencesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "data_source_references" */
export type DataSourceReferencesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type DataSourceTemplatePropertySchemaSetsAggregateBoolExp = {
  count?: DataSourceTemplatePropertySchemaSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_template_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatePropertySchemaSetsBoolExp = {
  _and?: Array<DataSourceTemplatePropertySchemaSetsBoolExp> | null | undefined;
  _not?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<DataSourceTemplatePropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceTemplate?: DataSourceTemplatesBoolExp | null | undefined;
  dataSourceTemplateId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataSourceTemplateId'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "data_source_templates". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatesBoolExp = {
  _and?: Array<DataSourceTemplatesBoolExp> | null | undefined;
  _not?: DataSourceTemplatesBoolExp | null | undefined;
  _or?: Array<DataSourceTemplatesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceTemplatePropertySchemaSet?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  dataSourceTemplatePropertySchemaSetAggregate?: DataSourceTemplatePropertySchemaSetsAggregateBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "data_sources". All fields are combined with a logical 'AND'. */
export type DataSourcesBoolExp = {
  _and?: Array<DataSourcesBoolExp> | null | undefined;
  _not?: DataSourcesBoolExp | null | undefined;
  _or?: Array<DataSourcesBoolExp> | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceGSheets?: DataSourceGsheetsBoolExp | null | undefined;
  dataSourceImportProjects?: DataSourceImportProjectsBoolExp | null | undefined;
  dataSourceImportProjectsAggregate?: DataSourceImportProjectsAggregateBoolExp | null | undefined;
  dataSourceJson?: DataSourceJsonsBoolExp | null | undefined;
  dataSourcePropertySchemaSet?: DataSourcePropertySchemaSetsBoolExp | null | undefined;
  dataSourcePropertySchemaSetAggregate?: DataSourcePropertySchemaSetsAggregateBoolExp | null | undefined;
  dataSourceReferences?: DataSourceReferencesBoolExp | null | undefined;
  dataSourceReferencesAggregate?: DataSourceReferencesAggregateBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "entity_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type EntityRecordComposerDefinitionsBoolExp = {
  _and?: Array<EntityRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: EntityRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<EntityRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "entity_records". All fields are combined with a logical 'AND'. */
export type EntityRecordsBoolExp = {
  _and?: Array<EntityRecordsBoolExp> | null | undefined;
  _not?: EntityRecordsBoolExp | null | undefined;
  _or?: Array<EntityRecordsBoolExp> | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  sourceRecordEdges?: SourceRecordEdgesBoolExp | null | undefined;
  sourceRecordEdgesAggregate?: SourceRecordEdgesAggregateBoolExp | null | undefined;
  targetRecordEdges?: TargetRecordEdgesBoolExp | null | undefined;
  targetRecordEdgesAggregate?: TargetRecordEdgesAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type EvidenceChangeRequestsAggregateBoolExp = {
  count?: EvidenceChangeRequestsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_change_requests". All fields are combined with a logical 'AND'. */
export type EvidenceChangeRequestsBoolExp = {
  _and?: Array<EvidenceChangeRequestsBoolExp> | null | undefined;
  _not?: EvidenceChangeRequestsBoolExp | null | undefined;
  _or?: Array<EvidenceChangeRequestsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  evidenceVersionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "evidence_change_requests" */
export type EvidenceChangeRequestsSelectColumn =
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceVersionId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type EvidenceEvidenceSetsAggregateBoolExp = {
  count?: EvidenceEvidenceSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceEvidenceSetsBoolExp = {
  _and?: Array<EvidenceEvidenceSetsBoolExp> | null | undefined;
  _not?: EvidenceEvidenceSetsBoolExp | null | undefined;
  _or?: Array<EvidenceEvidenceSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "evidence_importers". All fields are combined with a logical 'AND'. */
export type EvidenceImportersBoolExp = {
  _and?: Array<EvidenceImportersBoolExp> | null | undefined;
  _not?: EvidenceImportersBoolExp | null | undefined;
  _or?: Array<EvidenceImportersBoolExp> | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  definition?: JsonbComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type EvidenceRecordGeoItemsAggregateBoolExp = {
  count?: EvidenceRecordGeoItemsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_record_geo_items". All fields are combined with a logical 'AND'. */
export type EvidenceRecordGeoItemsBoolExp = {
  _and?: Array<EvidenceRecordGeoItemsBoolExp> | null | undefined;
  _not?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  _or?: Array<EvidenceRecordGeoItemsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  evidenceVersionId?: UuidComparisonExp | null | undefined;
  geoItemId?: UuidComparisonExp | null | undefined;
  recordGeoItem?: RecordGeoItemsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceVersionId'
  /** column name */
  | 'geoItemId'
  /** column name */
  | 'recordId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type EvidenceSetImportProjectsAggregateBoolExp = {
  count?: EvidenceSetImportProjectsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_set_import_projects". All fields are combined with a logical 'AND'. */
export type EvidenceSetImportProjectsBoolExp = {
  _and?: Array<EvidenceSetImportProjectsBoolExp> | null | undefined;
  _not?: EvidenceSetImportProjectsBoolExp | null | undefined;
  _or?: Array<EvidenceSetImportProjectsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "evidence_set_property_schema_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetPropertySchemaSetsBoolExp = {
  _and?: Array<EvidenceSetPropertySchemaSetsBoolExp> | null | undefined;
  _not?: EvidenceSetPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<EvidenceSetPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetsBoolExp = {
  _and?: Array<EvidenceSetsBoolExp> | null | undefined;
  _not?: EvidenceSetsBoolExp | null | undefined;
  _or?: Array<EvidenceSetsBoolExp> | null | undefined;
  batchChangeRequestsJobs?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobsAggregate?: BatchChangeRequestsJobsAggregateBoolExp | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  evidenceEvidenceSets?: EvidenceEvidenceSetsBoolExp | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateBoolExp | null | undefined;
  evidenceSetImportProjects?: EvidenceSetImportProjectsBoolExp | null | undefined;
  evidenceSetImportProjectsAggregate?: EvidenceSetImportProjectsAggregateBoolExp | null | undefined;
  evidenceSetPropertySchemaSet?: EvidenceSetPropertySchemaSetsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordComposerDefinitionEvidenceSets?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  recordComposerDefinitionEvidenceSetsAggregate?: RecordComposerDefinitionEvidenceSetsAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type EvidenceVersionsAggregateBoolExp = {
  count?: EvidenceVersionsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_versions". All fields are combined with a logical 'AND'. */
export type EvidenceVersionsBoolExp = {
  _and?: Array<EvidenceVersionsBoolExp> | null | undefined;
  _not?: EvidenceVersionsBoolExp | null | undefined;
  _or?: Array<EvidenceVersionsBoolExp> | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  caller?: StringComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  evidenceChangeRequestsAggregate?: EvidenceChangeRequestsAggregateBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSetIdArray?: UuidArrayComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobRunId?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  operation?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
  wikipediaJson?: JsonbComparisonExp | null | undefined;
};

/** select columns of table "evidence_versions" */
export type EvidenceVersionsSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'caller'
  /** column name */
  | 'citation'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'evidenceSetIdArray'
  /** column name */
  | 'id'
  /** column name */
  | 'jobRunId'
  /** column name */
  | 'metadata'
  /** column name */
  | 'operation'
  /** column name */
  | 'properties'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'userId'
  /** column name */
  | 'version'
  /** column name */
  | 'wikipediaJson';

export type EvidencesAggregateBoolExp = {
  count?: EvidencesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "evidences". All fields are combined with a logical 'AND'. */
export type EvidencesBoolExp = {
  _and?: Array<EvidencesBoolExp> | null | undefined;
  _not?: EvidencesBoolExp | null | undefined;
  _or?: Array<EvidencesBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  batchEvidencesJobRun?: BatchEvidencesJobRunsBoolExp | null | undefined;
  batchEvidencesJobRunId?: UuidComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  evidenceChangeRequestsAggregate?: EvidenceChangeRequestsAggregateBoolExp | null | undefined;
  evidenceEvidenceSets?: EvidenceEvidenceSetsBoolExp | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateBoolExp | null | undefined;
  evidenceImporter?: EvidenceImportersBoolExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceRecordGeoItems?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  evidenceRecordGeoItemsAggregate?: EvidenceRecordGeoItemsAggregateBoolExp | null | undefined;
  evidenceVersions?: EvidenceVersionsBoolExp | null | undefined;
  evidenceVersionsAggregate?: EvidenceVersionsAggregateBoolExp | null | undefined;
  headVersion?: EvidenceVersionsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
  wikipediaJson?: JsonbComparisonExp | null | undefined;
};

/** select columns of table "evidences" */
export type EvidencesSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'batchEvidencesJobRunId'
  /** column name */
  | 'citation'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'properties'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'version'
  /** column name */
  | 'wikipediaJson';

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

export type JsonbCastExp = {
  String?: StringComparisonExp | null | undefined;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: JsonbCastExp | null | undefined;
  /** is the column contained in the given json value */
  _containedIn?: Types.JsonObject | null | undefined;
  /** does the column contain the given json value at the top level */
  _contains?: Types.JsonObject | null | undefined;
  _eq?: Types.JsonObject | null | undefined;
  _gt?: Types.JsonObject | null | undefined;
  _gte?: Types.JsonObject | null | undefined;
  /** does the string exist as a top-level key in the column */
  _hasKey?: string | null | undefined;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: Array<string> | null | undefined;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: Array<string> | null | undefined;
  _in?: Array<Types.JsonObject> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Types.JsonObject | null | undefined;
  _lte?: Types.JsonObject | null | undefined;
  _neq?: Types.JsonObject | null | undefined;
  _nin?: Array<Types.JsonObject> | null | undefined;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: string | null | undefined;
  /** does array contain an ancestor of `ltree`? */
  _ancestorAny?: Array<string> | null | undefined;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: string | null | undefined;
  /** does array contain a descendant of `ltree`? */
  _descendantAny?: Array<string> | null | undefined;
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  /** does `ltree` match `lquery`? */
  _matches?: unknown;
  /** does `ltree` match any `lquery` in array? */
  _matchesAny?: Array<string> | null | undefined;
  /** does `ltree` match `ltxtquery`? */
  _matchesFulltext?: unknown;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: Array<OrganizationsBoolExp> | null | undefined;
  _not?: OrganizationsBoolExp | null | undefined;
  _or?: Array<OrganizationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  kind?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenants?: TenantsBoolExp | null | undefined;
  tenantsAggregate?: TenantsAggregateBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ProductRolesAggregateBoolExp = {
  count?: ProductRolesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "product_roles". All fields are combined with a logical 'AND'. */
export type ProductRolesBoolExp = {
  _and?: Array<ProductRolesBoolExp> | null | undefined;
  _not?: ProductRolesBoolExp | null | undefined;
  _or?: Array<ProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "product_roles" */
export type ProductRolesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'productId'
  /** column name */
  | 'roleId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type ProductsBoolExp = {
  _and?: Array<ProductsBoolExp> | null | undefined;
  _not?: ProductsBoolExp | null | undefined;
  _or?: Array<ProductsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  importDirectWebhookUrl?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  originHosts?: StringComparisonExp | null | undefined;
  productRoles?: ProductRolesBoolExp | null | undefined;
  productRolesAggregate?: ProductRolesAggregateBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userProductRolesAggregate?: UserProductRolesAggregateBoolExp | null | undefined;
};

export type PropertySchemaAssociationsAggregateBoolExp = {
  bool_and?: PropertySchemaAssociationsAggregateBoolExpBool_And | null | undefined;
  bool_or?: PropertySchemaAssociationsAggregateBoolExpBool_Or | null | undefined;
  count?: PropertySchemaAssociationsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "property_schema_associations". All fields are combined with a logical 'AND'. */
export type PropertySchemaAssociationsBoolExp = {
  _and?: Array<PropertySchemaAssociationsBoolExp> | null | undefined;
  _not?: PropertySchemaAssociationsBoolExp | null | undefined;
  _or?: Array<PropertySchemaAssociationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  position?: IntComparisonExp | null | undefined;
  propertyAttributeTypeId?: StringComparisonExp | null | undefined;
  propertySchema?: PropertySchemasBoolExp | null | undefined;
  propertySchemaId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  required?: BooleanComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  unique?: BooleanComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "property_schema_associations" */
export type PropertySchemaAssociationsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'position'
  /** column name */
  | 'propertyAttributeTypeId'
  /** column name */
  | 'propertySchemaId'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'required'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'unique'
  /** column name */
  | 'updatedAt';

/** select "propertySchemaAssociationsAggregateBoolExpBool_andArgumentsColumns" columns of table "property_schema_associations" */
export type PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'required'
  /** column name */
  | 'unique';

/** select "propertySchemaAssociationsAggregateBoolExpBool_orArgumentsColumns" columns of table "property_schema_associations" */
export type PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'required'
  /** column name */
  | 'unique';

/** Boolean expression to filter rows from the table "property_schema_sets". All fields are combined with a logical 'AND'. */
export type PropertySchemaSetsBoolExp = {
  _and?: Array<PropertySchemaSetsBoolExp> | null | undefined;
  _not?: PropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<PropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  propertySchemaAssociations?: PropertySchemaAssociationsBoolExp | null | undefined;
  propertySchemaAssociationsAggregate?: PropertySchemaAssociationsAggregateBoolExp | null | undefined;
  propertySchemaSet?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "property_schemas". All fields are combined with a logical 'AND'. */
export type PropertySchemasBoolExp = {
  _and?: Array<PropertySchemasBoolExp> | null | undefined;
  _not?: PropertySchemasBoolExp | null | undefined;
  _or?: Array<PropertySchemasBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  propertySchemaAssociation?: PropertySchemaAssociationsBoolExp | null | undefined;
  propertyTypeId?: StringComparisonExp | null | undefined;
  propertyValueDagId?: UuidComparisonExp | null | undefined;
  propertyValueLinkFilterId?: UuidComparisonExp | null | undefined;
  selectOptions?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  urlAllowList?: JsonbComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "publishers". All fields are combined with a logical 'AND'. */
export type PublishersBoolExp = {
  _and?: Array<PublishersBoolExp> | null | undefined;
  _not?: PublishersBoolExp | null | undefined;
  _or?: Array<PublishersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  referencePublishers?: ReferencePublishersBoolExp | null | undefined;
  referencePublishersAggregate?: ReferencePublishersAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type RecordComposerDefinitionEvidenceSetsAggregateBoolExp = {
  count?: RecordComposerDefinitionEvidenceSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_composer_definition_evidence_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionEvidenceSetsBoolExp = {
  _and?: Array<RecordComposerDefinitionEvidenceSetsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionEvidenceSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId';

export type RecordComposerDefinitionPropertySchemaSetsAggregateBoolExp = {
  count?: RecordComposerDefinitionPropertySchemaSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_composer_definition_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionPropertySchemaSetsBoolExp = {
  _and?: Array<RecordComposerDefinitionPropertySchemaSetsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionsBoolExp = {
  _and?: Array<RecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionsBoolExp> | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitions?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  changeRequestRecordComposerDefinitions?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  changeRequestRecordComposerDefinitionsAggregate?: ChangeRequestRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectRecordComposerDefinition?: DataImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  dataSourceImportProjectRecordComposerDefinition?: DataSourceImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  definition?: JsonbComparisonExp | null | undefined;
  entityComposerDefinition?: EntityRecordComposerDefinitionsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordComposerDefinitionEvidenceSets?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  recordComposerDefinitionEvidenceSetsAggregate?: RecordComposerDefinitionEvidenceSetsAggregateBoolExp | null | undefined;
  recordComposerDefinitionPropertySchemaSet?: RecordComposerDefinitionPropertySchemaSetsBoolExp | null | undefined;
  recordComposerDefinitionPropertySchemaSetAggregate?: RecordComposerDefinitionPropertySchemaSetsAggregateBoolExp | null | undefined;
  recordUpdateComposerDefinition?: RecordUpdateRecordComposerDefinitionsBoolExp | null | undefined;
  relationComposerDefinition?: RelationRecordComposerDefinitionsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type RecordGeoItemsAggregateBoolExp = {
  count?: RecordGeoItemsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_geo_items". All fields are combined with a logical 'AND'. */
export type RecordGeoItemsBoolExp = {
  _and?: Array<RecordGeoItemsBoolExp> | null | undefined;
  _not?: RecordGeoItemsBoolExp | null | undefined;
  _or?: Array<RecordGeoItemsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  date?: StringComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  endDate?: StringComparisonExp | null | undefined;
  evidenceRecordGeoItems?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  evidenceRecordGeoItemsAggregate?: EvidenceRecordGeoItemsAggregateBoolExp | null | undefined;
  geoItemId?: UuidComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "record_geo_items" */
export type RecordGeoItemsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'date'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'endDate'
  /** column name */
  | 'geoItemId'
  /** column name */
  | 'i18nLabel'
  /** column name */
  | 'metadata'
  /** column name */
  | 'recordId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "record_metadata". All fields are combined with a logical 'AND'. */
export type RecordMetadataBoolExp = {
  _and?: Array<RecordMetadataBoolExp> | null | undefined;
  _not?: RecordMetadataBoolExp | null | undefined;
  _or?: Array<RecordMetadataBoolExp> | null | undefined;
  changeRequestItemRecordMetadata?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  changeRequestItemRecordMetadataAggregate?: ChangeRequestItemRecordMetadataAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  data?: JsonbComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceLineageIdentity?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordDeactivatedAt?: TimestamptzComparisonExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  recordMetadataCategories?: RecordMetadataCategoriesBoolExp | null | undefined;
  recordMetadataCategoriesAggregate?: RecordMetadataCategoriesAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
};

export type RecordMetadataCategoriesAggregateBoolExp = {
  count?: RecordMetadataCategoriesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_metadata_categories". All fields are combined with a logical 'AND'. */
export type RecordMetadataCategoriesBoolExp = {
  _and?: Array<RecordMetadataCategoriesBoolExp> | null | undefined;
  _not?: RecordMetadataCategoriesBoolExp | null | undefined;
  _or?: Array<RecordMetadataCategoriesBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "record_metadata_categories" */
export type RecordMetadataCategoriesSelectColumn =
  /** column name */
  | 'categoryId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'recordMetadataId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type RecordPropertySchemaSetsAggregateBoolExp = {
  count?: RecordPropertySchemaSetsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordPropertySchemaSetsBoolExp = {
  _and?: Array<RecordPropertySchemaSetsBoolExp> | null | undefined;
  _not?: RecordPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<RecordPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "record_property_schema_sets" */
export type RecordPropertySchemaSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'propertySchemaSetId'
  /** column name */
  | 'recordId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "record_update_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordUpdateRecordComposerDefinitionsBoolExp = {
  _and?: Array<RecordUpdateRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RecordUpdateRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RecordUpdateRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "records". All fields are combined with a logical 'AND'. */
export type RecordsBoolExp = {
  _and?: Array<RecordsBoolExp> | null | undefined;
  _not?: RecordsBoolExp | null | undefined;
  _or?: Array<RecordsBoolExp> | null | undefined;
  changeRequestItemRecords?: ChangeRequestItemRecordsBoolExp | null | undefined;
  changeRequestItemRecordsAggregate?: ChangeRequestItemRecordsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  date?: StringComparisonExp | null | undefined;
  dateJdn?: IntComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  endDate?: StringComparisonExp | null | undefined;
  endDateJdn?: IntComparisonExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  nameJa?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  recordGeoItems?: RecordGeoItemsBoolExp | null | undefined;
  recordGeoItemsAggregate?: RecordGeoItemsAggregateBoolExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  recordPropertySchemaSets?: RecordPropertySchemaSetsBoolExp | null | undefined;
  recordPropertySchemaSetsAggregate?: RecordPropertySchemaSetsAggregateBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
};

export type ReferenceFilesAggregateBoolExp = {
  bool_and?: ReferenceFilesAggregateBoolExpBool_And | null | undefined;
  bool_or?: ReferenceFilesAggregateBoolExpBool_Or | null | undefined;
  count?: ReferenceFilesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "reference_files". All fields are combined with a logical 'AND'. */
export type ReferenceFilesBoolExp = {
  _and?: Array<ReferenceFilesBoolExp> | null | undefined;
  _not?: ReferenceFilesBoolExp | null | undefined;
  _or?: Array<ReferenceFilesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  folioOffset?: IntComparisonExp | null | undefined;
  googleDriveFileId?: StringComparisonExp | null | undefined;
  googleDriveFileVersion?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  imagesCreatedAt?: TimestamptzComparisonExp | null | undefined;
  imagesS3UriPrefix?: StringComparisonExp | null | undefined;
  latest?: BooleanComparisonExp | null | undefined;
  mimeType?: StringComparisonExp | null | undefined;
  numPages?: IntComparisonExp | null | undefined;
  originalFileS3Uri?: StringComparisonExp | null | undefined;
  originalFileUploadedAt?: TimestamptzComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "reference_files" */
export type ReferenceFilesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'folioOffset'
  /** column name */
  | 'googleDriveFileId'
  /** column name */
  | 'googleDriveFileVersion'
  /** column name */
  | 'id'
  /** column name */
  | 'imagesCreatedAt'
  /** column name */
  | 'imagesS3UriPrefix'
  /** column name */
  | 'latest'
  /** column name */
  | 'mimeType'
  /** column name */
  | 'numPages'
  /** column name */
  | 'originalFileS3Uri'
  /** column name */
  | 'originalFileUploadedAt'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** select "referenceFilesAggregateBoolExpBool_andArgumentsColumns" columns of table "reference_files" */
export type ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'latest';

/** select "referenceFilesAggregateBoolExpBool_orArgumentsColumns" columns of table "reference_files" */
export type ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'latest';

export type ReferencePublishersAggregateBoolExp = {
  count?: ReferencePublishersAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "reference_publishers". All fields are combined with a logical 'AND'. */
export type ReferencePublishersBoolExp = {
  _and?: Array<ReferencePublishersBoolExp> | null | undefined;
  _not?: ReferencePublishersBoolExp | null | undefined;
  _or?: Array<ReferencePublishersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  publisher?: PublishersBoolExp | null | undefined;
  publisherId?: UuidComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "reference_publishers" */
export type ReferencePublishersSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'publisherId'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId';

/** Boolean expression to filter rows from the table "references". All fields are combined with a logical 'AND'. */
export type ReferencesBoolExp = {
  _and?: Array<ReferencesBoolExp> | null | undefined;
  _not?: ReferencesBoolExp | null | undefined;
  _or?: Array<ReferencesBoolExp> | null | undefined;
  authors?: StringArrayComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceReferences?: DataSourceReferencesBoolExp | null | undefined;
  dataSourceReferencesAggregate?: DataSourceReferencesAggregateBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  edition?: StringComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  isbn?: StringComparisonExp | null | undefined;
  publishedDate?: StringComparisonExp | null | undefined;
  referenceFiles?: ReferenceFilesBoolExp | null | undefined;
  referenceFilesAggregate?: ReferenceFilesAggregateBoolExp | null | undefined;
  referencePublishers?: ReferencePublishersBoolExp | null | undefined;
  referencePublishersAggregate?: ReferencePublishersAggregateBoolExp | null | undefined;
  seq?: IntComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  title?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RelationRecordComposerDefinitionsBoolExp = {
  _and?: Array<RelationRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RelationRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RelationRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_records". All fields are combined with a logical 'AND'. */
export type RelationRecordsBoolExp = {
  _and?: Array<RelationRecordsBoolExp> | null | undefined;
  _not?: RelationRecordsBoolExp | null | undefined;
  _or?: Array<RelationRecordsBoolExp> | null | undefined;
  firstSourceRecordEdge?: SourceRecordEdgesBoolExp | null | undefined;
  firstTargetRecordEdge?: TargetRecordEdgesBoolExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  sourceRecordEdges?: SourceRecordEdgesBoolExp | null | undefined;
  sourceRecordEdgesAggregate?: SourceRecordEdgesAggregateBoolExp | null | undefined;
  targetRecordEdges?: TargetRecordEdgesBoolExp | null | undefined;
  targetRecordEdgesAggregate?: TargetRecordEdgesAggregateBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

export type RelationTypesAggregateBoolExp = {
  count?: RelationTypesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_types". All fields are combined with a logical 'AND'. */
export type RelationTypesBoolExp = {
  _and?: Array<RelationTypesBoolExp> | null | undefined;
  _not?: RelationTypesBoolExp | null | undefined;
  _or?: Array<RelationTypesBoolExp> | null | undefined;
  categories?: CategoriesBoolExp | null | undefined;
  categoriesAggregate?: CategoriesAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  sourceCategory?: CategoriesBoolExp | null | undefined;
  sourceCategoryId?: UuidComparisonExp | null | undefined;
  targetCategory?: CategoriesBoolExp | null | undefined;
  targetCategoryId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "relation_types" */
export type RelationTypesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'sourceCategoryId'
  /** column name */
  | 'targetCategoryId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: Array<RolesBoolExp> | null | undefined;
  _not?: RolesBoolExp | null | undefined;
  _or?: Array<RolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userProductRolesAggregate?: UserProductRolesAggregateBoolExp | null | undefined;
};

export type SourceRecordEdgesAggregateBoolExp = {
  count?: SourceRecordEdgesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "source_record_edges". All fields are combined with a logical 'AND'. */
export type SourceRecordEdgesBoolExp = {
  _and?: Array<SourceRecordEdgesBoolExp> | null | undefined;
  _not?: SourceRecordEdgesBoolExp | null | undefined;
  _or?: Array<SourceRecordEdgesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  entity?: RecordsBoolExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  entityRecordId?: UuidComparisonExp | null | undefined;
  relation?: RecordsBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  relationRecordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "source_record_edges" */
export type SourceRecordEdgesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'entityRecordId'
  /** column name */
  | 'relationRecordId'
  /** column name */
  | 'tenantId';

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _isNull?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

export type TargetRecordEdgesAggregateBoolExp = {
  count?: TargetRecordEdgesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "target_record_edges". All fields are combined with a logical 'AND'. */
export type TargetRecordEdgesBoolExp = {
  _and?: Array<TargetRecordEdgesBoolExp> | null | undefined;
  _not?: TargetRecordEdgesBoolExp | null | undefined;
  _or?: Array<TargetRecordEdgesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  entity?: RecordsBoolExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  entityRecordId?: UuidComparisonExp | null | undefined;
  relation?: RecordsBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  relationRecordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "target_record_edges" */
export type TargetRecordEdgesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'entityRecordId'
  /** column name */
  | 'relationRecordId'
  /** column name */
  | 'tenantId';

export type TenantProductInstallationsAggregateBoolExp = {
  count?: TenantProductInstallationsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "tenant_product_installations". All fields are combined with a logical 'AND'. */
export type TenantProductInstallationsBoolExp = {
  _and?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  _not?: TenantProductInstallationsBoolExp | null | undefined;
  _or?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  visibility?: StringComparisonExp | null | undefined;
};

/** select columns of table "tenant_product_installations" */
export type TenantProductInstallationsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'productId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visibility';

export type TenantsAggregateBoolExp = {
  bool_and?: TenantsAggregateBoolExpBool_And | null | undefined;
  bool_or?: TenantsAggregateBoolExpBool_Or | null | undefined;
  count?: TenantsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: Array<TenantsBoolExp> | null | undefined;
  _not?: TenantsBoolExp | null | undefined;
  _or?: Array<TenantsBoolExp> | null | undefined;
  allowAutoApproveChangeRequests?: BooleanComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  ownerUser?: UsersBoolExp | null | undefined;
  ownerUserId?: UuidComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenantProductInstallations?: TenantProductInstallationsBoolExp | null | undefined;
  tenantProductInstallationsAggregate?: TenantProductInstallationsAggregateBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
};

/** select columns of table "tenants" */
export type TenantsSelectColumn =
  /** column name */
  | 'allowAutoApproveChangeRequests'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'ownerUserId'
  /** column name */
  | 'shortCode'
  /** column name */
  | 'updatedAt';

/** select "tenantsAggregateBoolExpBool_andArgumentsColumns" columns of table "tenants" */
export type TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'allowAutoApproveChangeRequests';

/** select "tenantsAggregateBoolExpBool_orArgumentsColumns" columns of table "tenants" */
export type TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'allowAutoApproveChangeRequests';

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type UnifiedEvidenceDraftsAggregateBoolExp = {
  count?: UnifiedEvidenceDraftsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "unified_evidence_drafts". All fields are combined with a logical 'AND'. */
export type UnifiedEvidenceDraftsBoolExp = {
  _and?: Array<UnifiedEvidenceDraftsBoolExp> | null | undefined;
  _not?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  _or?: Array<UnifiedEvidenceDraftsBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  parentEvidenceId?: UuidComparisonExp | null | undefined;
  parentEvidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  parentEvidenceVersionId?: UuidComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  wikipedia?: JsonbComparisonExp | null | undefined;
};

/** select columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'citation'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'parentEvidenceId'
  /** column name */
  | 'parentEvidenceVersionId'
  /** column name */
  | 'properties'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'wikipedia';

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: Array<UserGroupsBoolExp> | null | undefined;
  _not?: UserGroupsBoolExp | null | undefined;
  _or?: Array<UserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  users?: UserUserGroupsBoolExp | null | undefined;
  usersAggregate?: UserUserGroupsAggregateBoolExp | null | undefined;
};

export type UserProductRolesAggregateBoolExp = {
  count?: UserProductRolesAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_roles". All fields are combined with a logical 'AND'. */
export type UserProductRolesBoolExp = {
  _and?: Array<UserProductRolesBoolExp> | null | undefined;
  _not?: UserProductRolesBoolExp | null | undefined;
  _or?: Array<UserProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "user_product_roles" */
export type UserProductRolesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'productId'
  /** column name */
  | 'roleId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "user_segments". All fields are combined with a logical 'AND'. */
export type UserSegmentsBoolExp = {
  _and?: Array<UserSegmentsBoolExp> | null | undefined;
  _not?: UserSegmentsBoolExp | null | undefined;
  _or?: Array<UserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: IntComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type UserTenantsAggregateBoolExp = {
  count?: UserTenantsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: Array<UserTenantsBoolExp> | null | undefined;
  _not?: UserTenantsBoolExp | null | undefined;
  _or?: Array<UserTenantsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  role?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "user_tenants" */
export type UserTenantsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'role'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'userId';

export type UserUserGroupsAggregateBoolExp = {
  count?: UserUserGroupsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_groups". All fields are combined with a logical 'AND'. */
export type UserUserGroupsBoolExp = {
  _and?: Array<UserUserGroupsBoolExp> | null | undefined;
  _not?: UserUserGroupsBoolExp | null | undefined;
  _or?: Array<UserUserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userGroup?: UserGroupsBoolExp | null | undefined;
  userGroupId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "user_user_groups" */
export type UserUserGroupsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'userGroupId'
  /** column name */
  | 'userId';

export type UserUserSegmentsAggregateBoolExp = {
  count?: UserUserSegmentsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_segments". All fields are combined with a logical 'AND'. */
export type UserUserSegmentsBoolExp = {
  _and?: Array<UserUserSegmentsBoolExp> | null | undefined;
  _not?: UserUserSegmentsBoolExp | null | undefined;
  _or?: Array<UserUserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  userSegment?: UserSegmentsBoolExp | null | undefined;
  userSegmentId?: IntComparisonExp | null | undefined;
};

/** select columns of table "user_user_segments" */
export type UserUserSegmentsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'userSegmentId';

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: Array<UsersBoolExp> | null | undefined;
  _not?: UsersBoolExp | null | undefined;
  _or?: Array<UsersBoolExp> | null | undefined;
  cotenId?: UuidComparisonExp | null | undefined;
  cotenLoginPreparationRequired?: BooleanComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  displayName?: StringComparisonExp | null | undefined;
  email?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  lockeRegistrationEmail?: StringComparisonExp | null | undefined;
  lockeRegistrationId?: UuidComparisonExp | null | undefined;
  memo?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  photoUrl?: StringComparisonExp | null | undefined;
  system?: BooleanComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userProductRolesAggregate?: UserProductRolesAggregateBoolExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
  userUserGroups?: UserUserGroupsBoolExp | null | undefined;
  userUserGroupsAggregate?: UserUserGroupsAggregateBoolExp | null | undefined;
  userUserSegments?: UserUserSegmentsBoolExp | null | undefined;
  userUserSegmentsAggregate?: UserUserSegmentsAggregateBoolExp | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type BatchChangeRequestReviewsJobRunsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestReviewsJobRunsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestReviewsJobRunsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestReviewsJobsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestReviewsJobsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobRunsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestsJobRunsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestsJobsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestsJobsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchEvidencesJobRunsAggregateBoolExpCount = {
  arguments?: Array<BatchEvidencesJobRunsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchEvidencesJobRunsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchEvidencesJobsAggregateBoolExpCount = {
  arguments?: Array<BatchEvidencesJobsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchEvidencesJobsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type CategoriesAggregateBoolExpCount = {
  arguments?: Array<CategoriesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: CategoriesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type CategoryPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: Array<CategoryPropertySchemaSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: CategoryPropertySchemaSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemCommitsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestItemCommitsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestItemCommitsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemRecordMetadataAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestItemRecordMetadataSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemRecordsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestItemRecordsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestItemRecordsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestItemsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestItemsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestRecordComposerDefinitionsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestReviewsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestReviewsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestReviewsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataImportProjectStatusLogsAggregateBoolExpCount = {
  arguments?: Array<DataImportProjectStatusLogsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataImportProjectStatusLogsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataImportProjectUsersAggregateBoolExpCount = {
  arguments?: Array<DataImportProjectUsersSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataImportProjectUsersBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataSourceImportProjectsAggregateBoolExpCount = {
  arguments?: Array<DataSourceImportProjectsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataSourceImportProjectsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataSourcePropertySchemaSetsAggregateBoolExpCount = {
  arguments?: Array<DataSourcePropertySchemaSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataSourcePropertySchemaSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataSourceReferencesAggregateBoolExpCount = {
  arguments?: Array<DataSourceReferencesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataSourceReferencesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type DataSourceTemplatePropertySchemaSetsAggregateBoolExpCount = {
  arguments?: Array<DataSourceTemplatePropertySchemaSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceChangeRequestsAggregateBoolExpCount = {
  arguments?: Array<EvidenceChangeRequestsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceChangeRequestsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceEvidenceSetsAggregateBoolExpCount = {
  arguments?: Array<EvidenceEvidenceSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceEvidenceSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceRecordGeoItemsAggregateBoolExpCount = {
  arguments?: Array<EvidenceRecordGeoItemsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceSetImportProjectsAggregateBoolExpCount = {
  arguments?: Array<EvidenceSetImportProjectsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceSetImportProjectsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceVersionsAggregateBoolExpCount = {
  arguments?: Array<EvidenceVersionsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceVersionsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidencesAggregateBoolExpCount = {
  arguments?: Array<EvidencesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidencesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ProductRolesAggregateBoolExpCount = {
  arguments?: Array<ProductRolesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ProductRolesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpBool_And = {
  arguments: PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: PropertySchemaAssociationsBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpBool_Or = {
  arguments: PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: PropertySchemaAssociationsBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpCount = {
  arguments?: Array<PropertySchemaAssociationsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: PropertySchemaAssociationsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordComposerDefinitionEvidenceSetsAggregateBoolExpCount = {
  arguments?: Array<RecordComposerDefinitionEvidenceSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordComposerDefinitionPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordComposerDefinitionPropertySchemaSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordGeoItemsAggregateBoolExpCount = {
  arguments?: Array<RecordGeoItemsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordGeoItemsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordMetadataCategoriesAggregateBoolExpCount = {
  arguments?: Array<RecordMetadataCategoriesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordMetadataCategoriesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: Array<RecordPropertySchemaSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordPropertySchemaSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ReferenceFilesAggregateBoolExpBool_And = {
  arguments: ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: ReferenceFilesBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type ReferenceFilesAggregateBoolExpBool_Or = {
  arguments: ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: ReferenceFilesBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type ReferenceFilesAggregateBoolExpCount = {
  arguments?: Array<ReferenceFilesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ReferenceFilesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ReferencePublishersAggregateBoolExpCount = {
  arguments?: Array<ReferencePublishersSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ReferencePublishersBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RelationTypesAggregateBoolExpCount = {
  arguments?: Array<RelationTypesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RelationTypesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type SourceRecordEdgesAggregateBoolExpCount = {
  arguments?: Array<SourceRecordEdgesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: SourceRecordEdgesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type TargetRecordEdgesAggregateBoolExpCount = {
  arguments?: Array<TargetRecordEdgesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: TargetRecordEdgesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type TenantProductInstallationsAggregateBoolExpCount = {
  arguments?: Array<TenantProductInstallationsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: TenantProductInstallationsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type TenantsAggregateBoolExpBool_And = {
  arguments: TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: TenantsBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type TenantsAggregateBoolExpBool_Or = {
  arguments: TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: boolean | null | undefined;
  filter?: TenantsBoolExp | null | undefined;
  predicate: BooleanComparisonExp;
};

export type TenantsAggregateBoolExpCount = {
  arguments?: Array<TenantsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: TenantsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UnifiedEvidenceDraftsAggregateBoolExpCount = {
  arguments?: Array<UnifiedEvidenceDraftsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserProductRolesAggregateBoolExpCount = {
  arguments?: Array<UserProductRolesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserProductRolesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: Array<UserTenantsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserTenantsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserUserGroupsAggregateBoolExpCount = {
  arguments?: Array<UserUserGroupsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserUserGroupsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserUserSegmentsAggregateBoolExpCount = {
  arguments?: Array<UserUserSegmentsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserUserSegmentsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type GetCategoriesQueryVariables = Exact<{
  where?: Types.CategoriesBoolExp | null | undefined;
}>;


export type GetCategoriesQuery = { categories: Array<{ __typename: 'Categories', id: string, name: string, i18nLabel: Types.JsonObject, description: string | null, typeId: string, documentUrl: string | null, updatedAt: string, deactivatedAt: string | null, categoryPath: { __typename: 'CategoryPaths', path: string } | null, relationType: { __typename: 'RelationTypes', id: string, name: string, sourceCategory: { __typename: 'Categories', id: string, name: string, i18nLabel: Types.JsonObject }, targetCategory: { __typename: 'Categories', id: string, name: string, i18nLabel: Types.JsonObject } } | null }> };


export const GetCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoriesBoolExp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"i18nLabel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"categoryPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"i18nLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"i18nLabel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;